import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import { TextInput, TrimTextInput, useInputHelper } from 'framework/form';
import { useShowContext } from 'framework/show';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import { PlusIcon, MinusIcon } from 'framework/ui/mui-builder';
import { IconButton } from '@mui/material';

const DualInputField = ({
  primarySource,
  secondarySource,
  placeholder,
  label,
  trimComponent = false,
}: {
  primarySource: string;
  secondarySource: string;
  placeholder: string;
  label: string;
  trimComponent?: boolean;
}) => {
  const inputHelper = useInputHelper({ source: secondarySource });
  const parentOnChangeCallback = inputHelper.getRawOnChangeCallback();

  const { data } = useShowContext();

  const InputComponent = trimComponent ? TextInput : TrimTextInput;

  const [visibleSecField, setVisibleSecField] = useState<boolean>(Boolean(data.getValueBySource(secondarySource)));

  const hideFieldHandler = async (values: FormFieldsData) => {
    setVisibleSecField(false);
    if (parentOnChangeCallback) {
      parentOnChangeCallback({
        [secondarySource]: null,
      });
    } else {
      // eslint-disable-next-line no-console
      console.error('parentOnChangeCallback is undefined');
    }
  };

  const onChangeCallback = (eventValue: any) => {
    if (parentOnChangeCallback) {
      parentOnChangeCallback({
        [secondarySource]: eventValue[secondarySource],
      });
    } else {
      // eslint-disable-next-line no-console
      console.error('parentOnChangeCallback is undefined');
    }
  };

  return (
    <Stack
      direction="column"
      gap="0.5rem"
      sx={{
        marginTop: '0 !important',
        marginBottom: 0,
        '& div': {
          marginBottom: 0,
        },
      }}
    >
      <Stack direction="row" alignItems="start">
        <InputComponent source={primarySource} label="" placeholder={placeholder} />
        {!visibleSecField && (
          <IconButton
            type="button"
            disableRipple
            onClick={() => setVisibleSecField(true)}
            sx={theme => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'common.white',
              backgroundColor: 'common.white',
              padding: '10px',
              margin: '-5px -10px -5px 0',
              border: 0,
              borderRadius: '50%',
              '&:hover': { backgroundColor: 'common.white' },
              '& svg:hover g > path': { fill: theme.palette.primary.dark },
              '& > svg': { width: '26px', minWidth: '26px', height: '28px' },
            })}
          >
            <PlusIcon />
          </IconButton>
        )}
      </Stack>
      {visibleSecField && (
        <Stack direction="row" alignItems="start">
          <InputComponent
            source={secondarySource}
            label={label}
            placeholder={`Additional ${placeholder}`}
            onChangeCallback={onChangeCallback}
            isVisible={visibleSecField}
          />

          <IconButton
            type="button"
            disableRipple
            onClick={hideFieldHandler}
            sx={theme => ({
              backgroundColor: 'primary.main',
              width: '26px',
              minWidth: '26px',
              height: '26px',
              borderRadius: '5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              border: 0,
              margin: '6px 0 6px 10px',
              '&:hover': { backgroundColor: 'primary.dark' },
              '& > svg': { width: '18px', fill: theme.palette.common.white },
            })}
          >
            <MinusIcon />
          </IconButton>
        </Stack>
      )}
    </Stack>
  );
};
export default DualInputField;
